export default "__VITE_ASSET__Cx0Ubz4o__"